module.exports = __webpack_public_path__ + "media/V41.b66ef487.mp4";